import React, {useEffect, useState} from 'react';
import axios from 'axios';
import "../css/PressCenter.css"
import { useParams, useNavigate, Link } from 'react-router-dom';
import Pagination from '../../Common/Component//Pagination.js';
import Text from '../../../common/Text.js';
import ImageView from "../../../common/ImageView"
// import Image from "d:/SOTEC_Web/src/main/frontend/src/user/CompanyInfo/img/비즈니스1.png"
import parse from 'html-react-parser';

function News() {
    //Header
    const [remainingHeight, setRemainingHeight] = useState(0);
    const [Display, setDisplay] = useState('none');
    
    const handleHover = (height) => {
    setRemainingHeight(height);
    console.log('Received Remaining height:', height);
    setDisplay('block');
    console.log('Received Remaining height:', Display);

    };
    const handleHoverEnd = () => {
    console.log('Hover ended in MainComponent');
    setDisplay('none');
    };


    
    const [allNewsLists, setAllNewsLists] = useState([]);
    const [filteredNewsLists, setFilteredNewsLists] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [searchCategory, setSearchCategory] = useState("all");

    const [page, setPage] = useState(1); //첫페이지를 몇번으로 할건지
    const [limit, setlimit] = useState(5); //한페이지단 보여줄 데이터개수
    const [total, setTotal] = useState(filteredNewsLists.length); // 선택할 몇개까지 나타낼건지
    const offset = (page -1) * limit; //전체 행개수로 카드분배
    const newsLists = filteredNewsLists.slice(offset, offset + limit); //페이지 번호별 카드갯수 나누기
       
    //navigate 
    const navigate = useNavigate();
    const handleCardClick = (Gbn) => {
        console.log(Gbn);
       navigate('/DetailItems', {
           state: {
               title: '보도자료',
               menukey: 1,
               cardkey: Gbn
           },
       });            
    };
    const handleLinkClick = (url) => {
       window.open(url)
    };


    const [isLoggedIn, setIsLoggedIn] = useState(false);


    // url주소가 있으면 링크 / 없으면 상세화면
    const handleClick = (list) =>{

        console.log(list.Gbn + 'Gbn');
        console.log(list.UploadID);
        console.log(list.Url );


        
            /*
                1. 첨부가 있을경우 무조건 => 카드
                2. 첨부가 있고 링크가 있을경우 => 카드 
                3. 첨부도 없고 링크도 없을경우 => 카드
                4. 첨부가 없고 링크가 있는경우 => 링크
            */

            // // 첨부가 없고 링크가 있는경우 => 링크
            if((list.UploadID == null || list.UploadID == undefined || list.UploadID == ''|| list.UploadID == 'null' || list.UploadID == "null" ||!(list.UploadID)) &&
            (list.Url != null && list.Url !== undefined && list.Url !== ''))
            {  
                console.log(list.Url + 'url');
                handleLinkClick(list.Url);
            }
            else
            {
                console.log(list.Gbn + 'Gbn');
                handleCardClick(list.Gbn); 
            }


        //         if( (list.Uploadid != null && list.Uploadid !== undefined && list.Uploadid !== '') ||
        //         (!(list.Uploadid != null && list.Uploadid !== undefined && list.Uploadid !== '') 
        //           && !(list.Noti_url != null && list.Noti_url !== undefined && list.Noti_url !== '' ))
        //    )
        //    {
        //         console.log(list.Gbn + 'Gbn');
        //         handleCardClick(list.Gbn);            
        //    }
        //    else if((list.Noti_url != null && list.Noti_url !== undefined && list.Noti_url !== '') && 
        //             !(list.Uploadid != null && list.Uploadid !== undefined && list.Uploadid !== '')){
        //         console.log(list.Noti_url + 'url');
        //         handleLinkClick(list.Noti_url);
        //     }
           



        // if(list.Url != null && list.Url != ""){
        //     console.log('여기는 링크');
        //     console.log(list.Url + 'url');
        //     handleLinkClick(list.Url);
        // }
        // else{
        //     console.log('여기는 카드');
        //     console.log(list.Gbn + 'Gbn');
        //     handleCardClick(list.Gbn);
        // }
        // console.log('여기는 암것도 아님');

    }


    // 글쓰기 새창
    const navigate2 = useNavigate();;
    const writeClick = (item, newsList) =>{
        
        //새글
        if(item === '01'){  
            console.log('추가');
            navigate2('/CreatePost', {
            state: {
                newsList: undefined,
                item : '01',
                MenuNm : 'News'
              },
        });  
        }
        //수정글
        else{
            console.log('수정');
            console.log(newsList);
            navigate2('/CreatePost', {
                state: {
                    firstnewsList: newsList,
                    newsList: newsList,
                      item : item,
                    MenuNm : 'News'
                },
            });  
        }
        
        
    }


    

    //Main Data
    useEffect ( () => {
        getNewsData();

        console.log('보도자료 시작');
        if(!isLoggedIn)
            {
    
    
                axios.post('/sessionCheck')
                .then((res) => {
                   
                console.log(res.data);
                    if(res.data=='인증완료')
                        {
                            setIsLoggedIn(true);
                        }
                    else
                        {
                            setIsLoggedIn(false);
                        }
                })
                 
            }


     }, [isLoggedIn]);
    
    const getNewsData = async () => {
        axios.get('/api/NewsMainSelect')
        .then(response => {
            setAllNewsLists(response.data);
            setFilteredNewsLists(response.data);
            console.log(response.data);
            setTotal(response.data.length);}
       )
       .catch(error => console.error("DB 가져오기 오류", error));
       console.log('total sucess');
       console.log('total sucess');
       console.log('total sucess');
    }
    console.log(getNewsData);
    console.log('total sucess??');
    
    //검색필터
    const handleSearch = () => {
        let filtered = allNewsLists;
        //제목+내용
        if (searchCategory === 'all') {
           
            filtered = allNewsLists.filter(newsList =>
                //newsList.Contents?.toLowerCase()
                newsList.Title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                newsList.Contents?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
                newsList.MediaComp?.toLowerCase().includes(searchTerm?.toLowerCase()) 
            );
        //제목
        } else if (searchCategory === 'title') {
            filtered = allNewsLists.filter(newsList =>
                newsList.Title.toLowerCase().includes(searchTerm.toLowerCase())
                
            );
        //내용
        } else if (searchCategory === 'content') {
            filtered = allNewsLists.filter(newsList =>
                newsList.Contents?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
                newsList.MediaComp?.toLowerCase().includes(searchTerm?.toLowerCase())
                
            );
        }
        setFilteredNewsLists(filtered);
        setTotal(filtered.length);
    }
    
    //엔터키로 검색
    const handleSearchEnter = (e) => {
        if(e.key === "Enter") {
            handleSearch();
        }
      }  


    return (
        <div className="wrappera" >
            <Text variant='titlename' className='TitleF'>보도자료</Text>

            {isLoggedIn ? (<button className='btnCreate' onClick={() => writeClick('01')}> {
             <Text variant="px16w400" >
              <div className='value1'></div></Text> 
             }
             글쓰기
             </button>):   <div></div>}

{/* (<div></div>) */}
            

            {newsLists.map((newsList,index)=>{
                console.log(index);
                console.log(newsList.Gbn);
                // console.log((index+1)%5 +"index");
                // console.log(total-limit +" index2");
                // console.log(page +" ipage2");
                // console.log(((index+1)%5 !== 0 || (index !== (total-limit)))+" ipage3");

                
                        const htmlString = newsList?.Contents;
                        const content = typeof htmlString === 'string' ? parse(htmlString) : '';

             return <div className="container-card list"  >
                 <div className="card-item">
                    <div className='cards' > 
                        <div className="imgView" onClick={() => handleClick(newsList)}>
                            
                        <ImageView fileId={newsList.FileID} />
                        
                        </div>
                        <div className='listbox' onClick={() => handleClick(newsList)}>
                            <Text variant='px24News'className="CardTitle">{newsList.Title}</Text>
                          <Text variant='px16w400c66' className="T1">{content}</Text>
                            <br/>
                            <div className='NewsUrl' > 
                                <Text variant="px16w400G" className='CardUrlM' > {newsList.MediaComp}</Text>
                                <Text variant='px16wB'> 
                                    <a className="CardUrl"  target={newsList.Url}> 
                                    {newsList.Url}
                                    </a>
                                </Text> 
                            </div>
                            
           
                        </div>
                        {isLoggedIn ? (
                        <div  style={{ display : "flex" , alignItems:"center", width: "170px", justifyContent:"center"}} >
                            <button className='btnUpdate' onClick={() => writeClick('02', newsList)}> {
                              <Text >
                              <div className='value1'></div>
                          </Text> } 수정
                            </button>
                        </div>) :  <div></div>}

                        {/* (<div></div>) */}
                    </div>
                </div> 
                {((index+1)%5 !== 0) && (<p className="LINE1"/>)}
            </div>
            })}  

         
            {/* 페이지네이션 */}
            <div style={{ display : 'flex', flexDirection: 'column', justifyContent : 'center', alignItems:"center", height :"200px", margin : '0px 0 0 0px'}}>
                {filteredNewsLists.length >=1 &&
                                <Pagination
                                total = {total}
                                limit = {limit}
                                page={page}
                                setPage={setPage}
                                />
                }
            </div>
            {/* 검색 */}
            <div className='search-container'>
                <div className='type-container_1'>
                    <select className='selectType' value={searchCategory} onChange={e => setSearchCategory(e.target.value)}>
                        <option value="title"> 제목</option>
                        <option value="content"> 내용</option>
                        <option value="all"> 제목 + 내용</option>
                    </select>
                </div>
                <div className='inputBrd'>
                    <input className='input'  
                    value={searchTerm}
                    onChange={e => setSearchTerm(e.target.value)}
                    onKeyDown={e => handleSearchEnter(e)}>
                    </input>
                </div>
                <button className='btnSearch' onClick={handleSearch}>
                    <Text variant="px18">검색</Text>
                </button>
            </div>        
            </div>
     );
 }
 
 export default News;